var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('NavBar'),_c('router-view'),_c('TrustpilotWidget',{staticClass:"tp-widget"}),_c('FooterInfo'),_c('CookieBanner'),(_vm.showLoadingPanel)?_c('LoadingPanel'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }